<section class="container-md">
  <div class="container" style="padding-right: 0px; padding-left: 0px;">
    <div class="card">
      <div class="card-header">
        <h4 class="mb-0"><strong>Parámetros de Rechazo de Cobro</strong></h4>
      </div>
      <div class="card-body">
        <p class="card-text">
          Configuración de parámetros para el proceso automático de rechazo de cobros.
        </p>

        <!-- Información de Última Ejecución -->
        <div class="alert alert-light border" role="alert" *ngIf="ultimaEjecucion">
          <i class="fa fa-clock-o"></i>
          <strong>Última Ejecución:</strong> {{ ultimaEjecucion | date:'dd/MM/yyyy HH:mm:ss' }}
        </div>
        <div class="alert alert-warning border" role="alert" *ngIf="!ultimaEjecucion && modoEdicion">
          <i class="fa fa-info-circle"></i>
          <strong>Información:</strong> No hay registro de ejecución previa.
        </div>

        <form [formGroup]="formulario" class="form-group" novalidate>
          <!-- Horarios -->
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="hora_ini"><strong>Hora Inicio <span class="text-danger">*</span></strong></label>
                <select 
                  id="hora_ini" 
                  class="form-control" 
                  formControlName="hora_ini"
                  [class.is-invalid]="formulario.get('hora_ini')?.invalid && formulario.get('hora_ini')?.touched">
                  <option value="">Seleccione una hora</option>
                  <option *ngFor="let hora of horasDisponibles" [value]="hora.value">
                    {{ hora.label }}
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="formulario.get('hora_ini')?.invalid && formulario.get('hora_ini')?.touched">
                  La hora de inicio es requerida
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label for="hora_fin"><strong>Hora Fin <span class="text-danger">*</span></strong></label>
                <select 
                  id="hora_fin" 
                  class="form-control" 
                  formControlName="hora_fin"
                  [class.is-invalid]="formulario.get('hora_fin')?.invalid && formulario.get('hora_fin')?.touched">
                  <option value="">Seleccione una hora</option>
                  <option *ngFor="let hora of horasDisponibles" [value]="hora.value">
                    {{ hora.label }}
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="formulario.get('hora_fin')?.invalid && formulario.get('hora_fin')?.touched">
                  La hora fin es requerida
                </div>
              </div>
            </div>
          </div>

          <!-- Frecuencia y Lapso -->
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="frecuencia"><strong>Frecuencia (minutos) <span class="text-danger">*</span></strong></label>
                <input 
                  type="number" 
                  id="frecuencia" 
                  class="form-control" 
                  formControlName="frecuencia"
                  min="1"
                  placeholder="Ingrese la frecuencia en minutos"
                  [class.is-invalid]="formulario.get('frecuencia')?.invalid && formulario.get('frecuencia')?.touched">
                <small class="form-text text-muted">
                  Cada cuántos minutos se ejecutará el proceso
                </small>
                <div class="invalid-feedback" *ngIf="formulario.get('frecuencia')?.invalid && formulario.get('frecuencia')?.touched">
                  La frecuencia debe ser mayor a 0
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label for="lapso_ejec"><strong>Lapso de Ejecución (minutos) <span class="text-danger">*</span></strong></label>
                <input 
                  type="number" 
                  id="lapso_ejec" 
                  class="form-control" 
                  formControlName="lapso_ejec"
                  min="1"
                  placeholder="Ingrese el lapso de ejecución en minutos"
                  [class.is-invalid]="formulario.get('lapso_ejec')?.invalid && formulario.get('lapso_ejec')?.touched">
                <small class="form-text text-muted">
                  Duración del proceso de ejecución
                </small>
                <div class="invalid-feedback" *ngIf="formulario.get('lapso_ejec')?.invalid && formulario.get('lapso_ejec')?.touched">
                  El lapso de ejecución debe ser mayor a 0
                </div>
              </div>
            </div>
          </div>

          <!-- Frecuencia Carga Extracto -->
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="carga_extracto"><strong>Frecuencia Carga extracto (minutos) <span class="text-danger">*</span></strong></label>
                <input 
                  type="number" 
                  id="carga_extracto" 
                  class="form-control" 
                  formControlName="carga_extracto"
                  min="1"
                  placeholder="Ingrese la frecuencia de carga del extracto"
                  [class.is-invalid]="formulario.get('carga_extracto')?.invalid && formulario.get('carga_extracto')?.touched">
                <small class="form-text text-muted">
                  Cada cuántos minutos se cargará el extracto
                </small>
                <div class="invalid-feedback" *ngIf="formulario.get('carga_extracto')?.invalid && formulario.get('carga_extracto')?.touched">
                  La frecuencia de carga del extracto debe ser mayor a 0
                </div>
              </div>
            </div>
          </div>

          <!-- Días de la Semana -->
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label><strong>Días de Ejecución <span class="text-danger">*</span></strong></label>
                <div class="dias-semana-container">
                  <div class="custom-control custom-checkbox custom-checkbox-inline">
                    <input 
                      type="checkbox" 
                      class="custom-control-input" 
                      id="lunes"
                      [checked]="isChecked('lunes')"
                      (change)="onCheckboxChange('lunes', $event)">
                    <label class="custom-control-label" for="lunes">Lunes</label>
                  </div>

                  <div class="custom-control custom-checkbox custom-checkbox-inline">
                    <input 
                      type="checkbox" 
                      class="custom-control-input" 
                      id="martes"
                      [checked]="isChecked('martes')"
                      (change)="onCheckboxChange('martes', $event)">
                    <label class="custom-control-label" for="martes">Martes</label>
                  </div>

                  <div class="custom-control custom-checkbox custom-checkbox-inline">
                    <input 
                      type="checkbox" 
                      class="custom-control-input" 
                      id="miercoles"
                      [checked]="isChecked('miercoles')"
                      (change)="onCheckboxChange('miercoles', $event)">
                    <label class="custom-control-label" for="miercoles">Miércoles</label>
                  </div>

                  <div class="custom-control custom-checkbox custom-checkbox-inline">
                    <input 
                      type="checkbox" 
                      class="custom-control-input" 
                      id="jueves"
                      [checked]="isChecked('jueves')"
                      (change)="onCheckboxChange('jueves', $event)">
                    <label class="custom-control-label" for="jueves">Jueves</label>
                  </div>

                  <div class="custom-control custom-checkbox custom-checkbox-inline">
                    <input 
                      type="checkbox" 
                      class="custom-control-input" 
                      id="viernes"
                      [checked]="isChecked('viernes')"
                      (change)="onCheckboxChange('viernes', $event)">
                    <label class="custom-control-label" for="viernes">Viernes</label>
                  </div>

                  <div class="custom-control custom-checkbox custom-checkbox-inline">
                    <input 
                      type="checkbox" 
                      class="custom-control-input" 
                      id="sabado"
                      [checked]="isChecked('sabado')"
                      (change)="onCheckboxChange('sabado', $event)">
                    <label class="custom-control-label" for="sabado">Sábado</label>
                  </div>

                  <div class="custom-control custom-checkbox custom-checkbox-inline">
                    <input 
                      type="checkbox" 
                      class="custom-control-input" 
                      id="domingo"
                      [checked]="isChecked('domingo')"
                      (change)="onCheckboxChange('domingo', $event)">
                    <label class="custom-control-label" for="domingo">Domingo</label>
                  </div>
                </div>
                <small class="form-text text-muted">
                  Seleccione los días en los que se ejecutará el proceso
                </small>
              </div>
            </div>
          </div>

          <!-- Botones de Acción -->
          <div class="row mt-4">
            <div class="col-md-6">
              <button 
                type="button" 
                class="btn btn-success btn-lg btn-block" 
                (click)="guardar()"
                [disabled]="loading">
                <i class="fa fa-save"></i>
                <span *ngIf="!loading"> {{ modoEdicion ? 'Guardar' : 'Guardar' }}</span>
                <span *ngIf="loading">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Guardando...
                </span>
              </button>
            </div>
            <div class="col-md-6">
              <button 
                type="button" 
                class="btn btn-danger btn-lg btn-block" 
                (click)="ejecutarRechazo()"
                [disabled]="loadingEjecucion">
                <i class="fa fa-ban"></i>
                <span *ngIf="!loadingEjecucion"> Ejecutar Rechazo</span>
                <span *ngIf="loadingEjecucion">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Ejecutando...
                </span>
              </button>
            </div>
          </div>
        </form>

        <!-- Información adicional -->
        <div class="row mt-4" *ngIf="modoEdicion">
          <div class="col-md-12">
            <div class="alert alert-info" role="alert">
              <i class="fa fa-info-circle"></i>
              <strong>Información:</strong> Ya existe una configuración guardada. Al guardar, se actualizará el registro existente.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
